import moment from 'moment';
import {
  ENABLE_STOP_BOOKING_FEATURE_PERIODS,
  STOP_BOOKING_FEATURE_PERIODS_DATE_FORMAT,
  UNAVAILABLE_CALENDAR_DATE,
} from '../constants';

export const createEmptyArray = (length) => new Array(Number(length)).fill(undefined);

export const validateNumber = (str) => (
  str.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248))
);

export const getAgeFromBirthday = (birthday) => moment().diff(birthday, 'years');

export const makePostalCodeDisplay = (postalCode) => {
  if (!postalCode) {
    return '';
  }

  return `${postalCode.substring(0, 3)} - ${postalCode.substring(3, 7)}`;
};

export const getPrefectureName = (prefectureId, prefectures) => {
  if (!(prefectures && prefectures.length)) {
    return '';
  }

  const prefecture = prefectures.find(({ id })=> id === prefectureId);

  if (!prefecture) {
    return '';
  }

  return prefecture.name;
};

export const getUnavailableCalendarDate = () => {
  const now = moment();
  const validStopBookingFeatrue = !!ENABLE_STOP_BOOKING_FEATURE_PERIODS.find(({ from, to }) => {
    if (!from || !to) {
      return false;
    }
    const fromDate = moment(from, STOP_BOOKING_FEATURE_PERIODS_DATE_FORMAT);
    const toDate = moment(to, STOP_BOOKING_FEATURE_PERIODS_DATE_FORMAT);

    return now.isAfter(fromDate) && now.isBefore(toDate);
  });

  return validStopBookingFeatrue ? UNAVAILABLE_CALENDAR_DATE : undefined;
};
